import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';

const AuthContext = createContext({});

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(localStorage.getItem('token'));

  useEffect(() => {
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      fetchUser();
    } else {
      setLoading(false);
    }
  }, [token]);


    const signup = async (userData) => {
    try {
      const response = await axios.post('/api/auth/signup', userData);
      return { success: true, userId: response.data.userId };
    } catch (error) {
      toast.error(error.response?.data?.error || 'Signup failed');
      throw error;
    }
  };

const fetchUser = async () => {
  try {
    const response = await axios.get('/api/users/profile');
    setUser(response.data.user);
  } catch (error) {
    console.error('Error fetching user:', error);
    // Clear token if unauthorized
    if (error.response?.status === 401) {
      logout();
    }
  } finally {
    setLoading(false);
  }
};


  const login = async (mobileNumber, password) => {
    try {
      const response = await axios.post('/api/auth/signin', { mobileNumber, password });
      
      if (response.data.requiresVerification) {
        return { requiresVerification: true, userId: response.data.userId };
      }

      const { token, user } = response.data;
      localStorage.setItem('token', token);
      setToken(token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      setUser(user);
      toast.success('Login successful!');
      return { success: true };
    } catch (error) {
      toast.error(error.response?.data?.error || 'Login failed');
      throw error;
    }
  };



  const verifyOTP = async (userId, otp) => {
    try {
      const response = await axios.post('/api/auth/verify-otp', { userId, otp });
      const { token, user } = response.data;
      localStorage.setItem('token', token);
      setToken(token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      setUser(user);
      toast.success('OTP verified successfully!');
      return { success: true };
    } catch (error) {
      toast.error(error.response?.data?.error || 'OTP verification failed');
      throw error;
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    setToken(null);
    setUser(null);
    delete axios.defaults.headers.common['Authorization'];
    toast.success('Logged out successfully');
  };

  const updateProfile = async (updates) => {
    try {
      const response = await axios.put('/api/users/profile', updates);
      setUser(response.data.user);
      toast.success('Profile updated successfully');
      return response.data.user;
    } catch (error) {
      toast.error(error.response?.data?.error || 'Update failed');
      throw error;
    }
  };

  const value = {
    user,
    login,
    signup,
    logout,
    verifyOTP,
    updateProfile,
    loading,
    isAuthenticated: !!user,
    isAdmin: user?.role === 'admin',
    isStudent: user?.role === 'student'
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};